import { render, staticRenderFns } from "./chooseAddGoods.vue?vue&type=template&id=0789c880&scoped=true"
import script from "./chooseAddGoods.vue?vue&type=script&lang=js"
export * from "./chooseAddGoods.vue?vue&type=script&lang=js"
import style0 from "./chooseAddGoods.vue?vue&type=style&index=0&id=0789c880&prod&scoped=true&lang=css"
import style1 from "./chooseAddGoods.vue?vue&type=style&index=1&id=0789c880&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0789c880",
  null
  
)

export default component.exports